export default __webpack_public_path__ + "static/COMPACT LAMINATES-5e677cf2386a3f56f5f027470ce63d66.webp";